import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export type ReactionType = 'LIKE' | 'LOVE' | 'HAHA' | 'WOW' | 'SAD' | 'ANGRY' | 'THUMBS_UP' | 'FIRE' | 'HEART';
export type ReactionTargetType = 'POST' | 'COMMENT';

export interface Reaction {
  id: string;
  userId: string;
  targetType: ReactionTargetType;
  targetId: string;
  reactionType: ReactionType;
  createdAt: string;
  user?: {
    id: string;
    username: string;
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
}

export interface ReactionCounts {
  [key: string]: number;
}

export interface AddReactionPayload {
  targetType: ReactionTargetType;
  targetId: string;
  reactionType: ReactionType;
}

export const reactionsService = {
  async addReaction(payload: AddReactionPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/reactions`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as {
      reaction: Reaction;
      reactionCounts: ReactionCounts;
      userReaction: ReactionType | null;
    };
  },

  async removeReaction(targetType: ReactionTargetType, targetId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/reactions`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { targetType, targetId },
    });
    return res.data as {
      reactionCounts: ReactionCounts;
      userReaction: null;
    };
  },

  async getReactions(targetType: ReactionTargetType, targetId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/reactions`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      params: { targetType, targetId },
    });
    return res.data as {
      reactionCounts: ReactionCounts;
      userReaction: ReactionType | null;
    };
  },
};


